/* eslint-disable max-len */
export default class PublicContent {
    signInBackgroundImageUrl: string = '';

    signInTitle: string = 'Sign in';

    signInInformation: string = 'Enter your email address';

    signInDescription: string = 'Have you previously signed in or started an application? Use your same email address.';

    signInAccountLocked: string = 'Your account is locked.Please contact us at 800-555-5555 for assistance!';

    signInNewUser: string = 'Create an account';

    signInNewUserInfo: string = 'For your security, we required a 8-digit verification code, which we sent you in an email. Please check your inbox to copy the code and enter it below.';

    homePageTitle: string = 'Home';

    homePageDescription: string = 'Welcome to your Client Portal. Any documents requested can be viewed on the Requested page or using the Details button in the Requested box below.';

    requestDocsPageTitle: string = 'Requested Documents';

    requestDocsPageDescription: string = 'The below documents have been requested to support a new or renewing loan or for ongoing needs. The document title describes the document needed and which entity the document is required for. If stated, the statement date or description will identity the statement period needed. If a due date is listed, please attempt to provide the document by this date. If the document cannot be returned by the due date, please contact us.';

    requestDocsHistoryPageTitle: string = 'History';

    requestDocsHistoryPageDescription: string = 'A summary of all documents uploaded through your client portal are listed below. Actual copies of the documents uploaded are not available here for security purposes.';

    externalApplicationPageTitle: string = 'Finance Opportunities';

    externalApplicationPageDescription: string = 'Below are some finance opportunities you may apply for. Each one has additional details and some may provide an immediate decision.';

    loanApplicationHistoryPageTitle: string = 'Loan Application History';

    loanApplicationHistoryPageDescription: string = 'All loan applications started online will be shown below. Select the application number for applications with a pending status to continue and complete the process. The Application Number link will provide the result of the applications that are completed.';

    newCommercialRequestTitle: string = 'New Commercial Loan Request';

    newCommercialRequestDescription: string = 'You can start a new commercial request by clicking the link below or selecting "New Commercial Request" from the menu.';

    newCommercialRequestHyperlinkText: string = 'Click to Start a New Commercial Loan Request';

    newConsumerRequestPageTitle: string = 'New Consumer Loan Request';

    newConsumerRequestPageDescription: string = 'Below are some finance opportunities you may apply for as individual. Each one has additional details and some may provide an immediate decision.';

    newConsumerRequestDescription: string = 'You can start a new consumer request by clicking the link below or selecting "New Consumer Request" from the menu.';

    newConsumerRequestHyperlinkText: string = 'Click to Start a New Consumer Loan Request';

    currentRequestPageTitle: string = 'Current Requests';

    currentRequestPageDescription: string = 'Below are current loan requests in process. Follow the status of your application and upload any needed documents to expedite the process.';

    id: BigInt;

    treatAllNulls: boolean;

    idUserLastModified: number;
}
